import styled from 'styled-components'

export const ContentProfile = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  padding: 90px 16px 16px;

  h1.title-profile {
    font-size: 2.4rem;
    line-height: 3rem;
    color: ${({ theme }) => theme.colors.black};
  }

  .container-config-profile {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    margin-top: 50px;

    @media screen and (min-width: 750px) {
      display: grid;
      grid-template-columns: 0.75fr 1.25fr;
    }
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`

export const FormContent = styled.div`
  .form-group {
    margin-top: 1rem;

    label {
      font-size: 1.6rem;
    }

    select {
      height: 48px;
      border: 1px solid ${({ theme }) => theme.colors.gray20};
      border-radius: ${({ theme }) => theme.radius.medium}px;
      padding: 0 16px;
      font-size: 1.4rem;
    }
  }

  .content-inputs {
    display: flex;
    flex-direction: column;

    .content-input {
      padding: 2px 0;
      margin-right: 10px;

      @media screen and (min-width: 750px) {
        margin-right: 0;
        width: 95%;
      }
    }

    @media screen and (min-width: 750px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  .new-password-demands {
    margin-top: 16px;

    p {
      margin-top: 16px;
    }

    ul {
      margin-top: 8px;
      list-style: none;

      li {
        padding-left: 8px;
      }
    }
  }

  .button-show-password {
    position: absolute;
    top: 50%;
    right: 32px;
    transform: translate(-50%);
    border: none;

    svg {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${({ theme }) => theme.colors.gray50};
    }
  }

  .area-button {
    width: 100%;
    max-width: 150px;
    margin-top: 30px;
  }
`

export const PhotoProfile = styled.div`
  padding: 0;
  margin-bottom: 2rem;
  padding-left: 0;

  .photo-section {
    margin-bottom: 40px;
  }

  .bio-section {
    margin-top: 40px;
  }

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    h3 {
      font-size: 1.6rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.black};
      margin: 0;
    }
  }

  .content-photo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    cursor: pointer;

    .photo-content-wrapper {
      position: relative;
      width: 140px;
      height: 140px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.gray10};
        object-fit: cover;
        cursor: pointer;
        pointer-events: auto; // Garante que a imagem recebe eventos de clique
      }

      .edit-photo-button {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.gray50 || '#6b7280'};
        border: 2px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
          background-color: ${({ theme }) => theme.colors.gray60 || '#4b5563'};
        }

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    @media screen and (min-width: 961px) {
      justify-content: flex-start;
    }
  }

  .bio-actions {
    margin-top: 16px;
    display: flex;
    justify-content: flex-start;
  }

  @media screen and (min-width: 961px) {
    margin-bottom: 0;
    padding-left: 50px;
  }
`

export const AISuggestionsButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.gray10 || '#f3f4f6'};
  border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
  border-radius: 8px;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.gray70 || '#374151'};
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 16px;
    height: 16px;
  }
`

export const BioTextArea = styled.div`
  width: 100%;

  textarea {
    width: 100%;
    min-height: 100px;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.colors.gray20 || '#e5e7eb'};
    border-radius: 8px;
    font-size: 1.4rem;
    font-family: inherit;
    resize: vertical;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary || '#007bff'};
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray40 || '#9ca3af'};
    }
  }
`

export const ProfessionalInfoContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
  width: 100%;

  @media screen and (max-width: 750px) {
    flex-direction: column;
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`

export const ProfessionalInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  h4 {
    font-size: 1.4rem;
    font-weight: 400;
    color: #667085;
    margin: 0;
  }

  #input-container {
    flex: 1;
    margin: 0;
    height: auto;
    min-height: 36px;
  }

  #input-container input {
    height: 36px;
    padding: 8px 0px;
  }

  @media screen and (max-width: 750px) {
    width: 100%;

    #input-container {
      width: 100%;
      flex: none;
    }
  }
`
